import type React from 'react';
import { useEffect, useState } from 'react';

import * as styles from './styles';

import { CaptionError, ConfirmationModal, type ConfirmationModalProps, DefaultInput, ModalType, useDebounce } from '@cobliteam/base-components';

export interface NewChecklistDialogProps extends Pick<ConfirmationModalProps, 'onCancel' | 'loading' | 'open'> {
  checklistNames: Map<string, string>;
  onConfirm: (name: string) => void;
}

const DEBOUNCE_TIME = 300;

export const NewChecklistDialog: React.FC<NewChecklistDialogProps> = ({ open, loading, onCancel, onConfirm, checklistNames }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(false);
  const debouncedInputtedName = useDebounce(name, DEBOUNCE_TIME);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleOnConfirmButtonClicked = () => {
    onConfirm(name);
  };

  useEffect(() => {
    setName('');
  }, [open]);

  useEffect(() => {
    if (checklistNames.has(debouncedInputtedName.toLowerCase())) {
      setError(true);
    } else if (error) {
      setError(false);
    }
  }, [debouncedInputtedName]);

  return (
    <ConfirmationModal
      open={open}
      loading={loading}
      onCancel={onCancel}
      onConfirm={handleOnConfirmButtonClicked}
      headerText='Nova checklist'
      buttonText='Criar'
      type={ModalType.SUBMIT}
      confirmationButtonProps={{
        disabled: error || !debouncedInputtedName,
      }}
    >
      <div className={styles.inputWrapper}>
        <DefaultInput error={error} placeholder='Nome da checklist' fullWidth onChange={handleOnChange} />
        {error && <CaptionError className={styles.captionError}>Já existe uma checklist com esse nome</CaptionError>}
      </div>
    </ConfirmationModal>
  );
};

export default NewChecklistDialog;
